import { PcApiResponse } from '@/api/pc-api/types';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export type DyingContract = {
  requestOrganizationName: string;
  productCode: string;
  finishedAt: string;
  remainDay: number;
  partnerId: string;
  svcId: string;
  settleId: string;
}[];

export const getDyingContract = () => {
  return api<PcApiResponse<DyingContract>>('get', `/pc-api/v1/${PREFIX_PATH}/dashboard/contract/dying`);
};
